import type { Language } from '../../types/i18n'
import type { CvContent } from './types'
import { nl } from './nl'
import { en } from './en'
import { de } from './de'
import { fr } from './fr'
import { es } from './es'

export type { CvContent, Experience, Education, SkillGroup } from './types'

export const profile = {
  firstName: 'Fauve',
  lastName: 'Willems',
  photo: 'https://cdn.magicpatterns.com/uploads/fywdmyYFGhrwgCMm4W1mBz/Fauve_1.jpg',
}

export const contact = {
  address: 'Amsterdam / Groningen',
  email: 'fauvejwillems@gmail.com',
  linkedin: {
    label: 'Fauve Willems',
    url: 'https://www.linkedin.com/in/fauve-willems-578b603a6/',
  },
  instagram: {
    label: '@fauve.willems',
    url: 'https://www.instagram.com/fauve.willems/',
  },
}

export const cv: Record<Language, CvContent> = { nl, en, de, fr, es }
